import React from 'react';

const Subscription = () => {
  return <div></div>;
};

export default Subscription;
